import React, { useCallback, useEffect, useState } from "react";
import { getManagedResourceTypesInApplication } from "../../actions/api";
import { connect, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import ManagedResourcesList from "./ManagedResourcesList";
import { List } from "antd";

const ManagedResourceTypesList = ({ serviceApplication, identity }) => {
  const dispatch = useDispatch();
  const [resourceTypes, setResourceTypes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchManagedResourcesTypes = useCallback(
    async (serviceApplication) => {
      setIsLoading(true);
      const action = await dispatch(
        getManagedResourceTypesInApplication(serviceApplication.id),
      );
      if (action && action.payload && action.payload.data)
        setResourceTypes(action.payload.data);
      setIsLoading(false);
    },
    [dispatch],
  );

  useEffect(() => {
    if (serviceApplication) fetchManagedResourcesTypes(serviceApplication);
  }, [fetchManagedResourcesTypes, serviceApplication]);

  return (
    resourceTypes &&
    resourceTypes.length > 0 && (
      <List
        grid={{ gutter: 16, column: 1 }}
        loading={isLoading}
        dataSource={resourceTypes}
        rowKey={(item) => item.id}
        renderItem={(item) => (
          <List.Item>
            <ManagedResourcesList
              managedResourceTypeName={item.resourceTypeName}
              identityId={identity?.id}
            />
          </List.Item>
        )}
        locale={{ emptyText: "No resource types found" }}
      />
    )
  );
};

ManagedResourceTypesList.propTypes = {
  serviceApplication: PropTypes.object.isRequired,
  identity: PropTypes.object,
};

export default connect(
  (state, props) => ({
    serviceApplication: props.serviceApplication,
    identity: props.identity,
  }),
  {},
)(ManagedResourceTypesList);
